import { render, staticRenderFns } from "./Various.vue?vue&type=template&id=472d581c&scoped=true&"
import script from "./Various.vue?vue&type=script&lang=js&"
export * from "./Various.vue?vue&type=script&lang=js&"
import style0 from "./Various.vue?vue&type=style&index=0&id=472d581c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d581c",
  null
  
)

export default component.exports